import LockType from './LockType';

export default LockType;
